<template src="./template.html"></template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

import Btn from "@/components/elements/buttons";
import LogosSVG from "@/assets/images/logosSVG";
import PriceCard from "./priceCard.vue";
import InputSelect from '@/components/elements/inputs/select.vue';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import Checkbox from '@/components/elements/inputs/checkbox.vue';
import Calendar from '@/components/elements/inputs/calendar.vue';
import Toggle from "@/components/elements/inputs/toggle.vue";
import EventBus from '@/eventBus.js';

export default {
  name: 'ToggleCard',
  components: {
    Btn,
    LogosSVG,
    PriceCard,
    Popup,
    Checkbox,
    InputSelect,
    InputText,
    Calendar,
    Toggle,
  },
  props: {
    editShipmentDroppointNo: {
      type: [String, Number],
      default: '',
    },
    pickupDate: {
      type: [String, Date],
      default: '',
    },
    showPrices: {
      type: [Boolean],
      default: false,
    },
    product: {
      type: Object,
      default: {},
    },
    enabledInsuranceCategory: {
      type: Boolean,
      default: false,
    },
    isOpened: {
      type: Boolean,
      default: false,
    },
    enabledProducts: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selectedServices: {
      type: Array,
      default: () => {
        return [];
      },
    },
    editPickupTimeFrom: {
      type: [String],
      default: '',
    },
    editPickupTimeUntil: {
      type: [String],
      default: '',
    },
    editPickupDriverNote: {
      type: [String],
      default: '',
    },
    customsData: {
      type: [Object],
      required: false
    },
  },
  data() {
    return{
      pickupAction: '',
      newPickupDate: '',
      pickupTimeFrom: '',
      pickupTimeUntil: '',
      pickupDriverNote: '',
      insuranceCategory: '',
      insuranceCategoriesOptions: [],
      isOpenedPopup: false,
      shipmentNotificationList: [
        {
          text: 'EOD',
          value: 1,
        },
      ],
      shipmentNotification: '1',
      pickupToggle: false,
      pickup_driver_note: '',
      otherNotificationEvent: '',
      freight_booking_confirmation_no: '',
      // Checkboxes
      selectedReciever: true,
      selectedShipper: false,
      selectedMe: false,
      selectedOther: false,
      selectedStatusChange: false,
      selectedDeviations: false,
      selectedDeliver: false,
      // Other
      APIerror: '',
      otherMail: '',
      droppointNo: '',
      user_vat_percent: '',
      droppointAddressOptions: [],
      scheduleHours: [
        '06:00', '06:15', '06:30', '06:45',
        '07:00', '07:15', '07:30', '07:45',
        '08:00', '08:15', '08:30', '08:45',
        '09:00', '09:15', '09:30', '09:45',
        '10:00', '10:15', '10:30', '10:45',
        '11:00', '11:15', '11:30', '11:45',
        '12:00', '12:15', '12:30', '12:45',
        '13:00', '13:15', '13:30', '13:45',
        '14:00', '14:15', '14:30', '14:45',
        '15:00', '15:15', '15:30', '15:45',
        '16:00', '16:15', '16:30', '16:45',
        '17:00', '17:15', '17:30', '17:45',
        '18:00', '18:15', '18:30', '18:45',
        '19:00', '19:15', '19:30', '19:45',
        '20:00',
      ],
    };
  },
  computed: {
    ...mapGetters([
      'get_booking_systems',
      'get_user',
      'get_active_subaccount',
      'get_currency',
      'get_payer_carriers',
      'get_is_ship365'
    ]),
    showPickupToggle() {
      //Show pickup toggle when product is drop off and pickup handling type
      const handlingTypes = this.product.product_handling_type.split(', ');
      return handlingTypes.includes('1') && handlingTypes.includes('2');
    },
    showPickupTimes() {
      // Case for bulk pickup handling type and import or three way product direction type
      let isBulkPickupAndImportOrThreeWay = (this.product.product_handling_type.split(', ').includes('3')) && ([3, 4].includes(parseInt(this.product.direction_type)));

      //Pickup toggle is on or product handling type is pickup
      return (this.pickupToggle === true) || (this.product.product_handling_type === '2') || isBulkPickupAndImportOrThreeWay;
    },
    showFreightConfirmationNo() {
      const showConfirmNoProducts = [
        'FedExInternationalPriorityFreightDtdExport',
        'FedExInternationalPriorityFreightDtdImport',
        'FedExInternationalEconomyFreightDtdExport',
        'FedExInternationalEconomyFreightDtdImport',
        'FedExRegionalEconomyFreight'
      ];
      return this.get_is_ship365 && showConfirmNoProducts.includes(this.product.carrier_product_name);
    },
    getPickupNotificationTxt() {
      if (this.product.pickup.message === 'pickup_has_been_booked_on_this_address') {
        return `${this.$t('pickup_has_been_booked_on_this_address')} </br> ${this.$t('between')} ${this.product.pickup.pickup_from} ${this.$t('and')} ${this.product.pickup.pickup_until}`;
      } else if (this.product.pickup.message === 'booked_pickup_exist_but_this_product_is_not_allowed_so_it_will_be_created_in_new_not_planned_pickup') {
        return `${this.$t('booked_pickup_exist_but_this_product_is_not_allowed_so_it_will_be_created_in_new_not_planned_pickup')} </br> ${this.product.pickup.pickup_from} ${this.product.pickup.pickup_until}`;
      } else {
        return this.$t(this.product.pickup.message);
      }
    },
    visibleBookingButton() {
      if(this.get_user.book_permission_type == 3) return false;
      if(this.get_active_subaccount.book_approval_type == 3) return false;
      return true;
    },
    getTransitTimeString() {
      if (this.product.estimated_time.value === '') {
        return this.$t('no_estimation');
      } else if (parseInt(this.product.estimated_time.value) === 0) {
        return this.$t('same_day');
      } else if (parseInt(this.product.estimated_time.value) === 1) {
        return this.$t('delivery_within_hours', [24]);
      } else {
        return this.$t('delivery_within_days', [this.product.estimated_time.value]);
      }
    },
    isDisabledByService() {
      if( this.enabledProducts.length > 0 ){
        if(!this.enabledProducts.includes(this.product.shipping_product_id)){
          return true;
        }
      }

      if( this.selectedServices.length > 0 && this.enabledProducts.length == 0) {
        return true;
      }
    },
    isDisabled() {
      if('error' in this.product.prices_data){
        if( this.product.prices_data.error.message == `Error with product id ${this.product.prices_data.error.product}. Error: agreement_product_data_not_found`){
          return false;
        }
        if( this.product.prices_data.error.message == `Error with product id ${this.product.prices_data.error.product}. Error: sales_product_price_data_not_found`){
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    isDisabledByPayer() {
      if (this.customsData?.freight_paid_by == 4 && !this.get_payer_carriers?.items?.find(item => item.shipping_agent_id == this.product.shipping_agent_id)) {
        return true;
      }
      return false
    },
    isDisabledByAPI() {
      if(this.product.api_errors.length > 0){
        this.product.api_errors.forEach((error) => {
          if(error.type == 'dot'){
            this.APIerror = this.$t(error.text, {
              a: error.params[0],
              b: error.params[1],
              c: error.params[2],
            })
          } else {
            this.APIerror = this.$t(error.text)
          }
        })
        return true;
      } else {
        return false;
      }
    },
    returnHoursArray() {
      let currentDate = this.getFormatedDate(new Date());
      let pickupDate = this.getFormatedDate(this.pickupDate);

      let startFromHour,
          endFromHour,
          startUntilHour,
          endUntilHour;

      let dayStartingTime;
      if(currentDate.date == pickupDate.date){
        dayStartingTime = currentDate.time;
      } else {
        dayStartingTime = '05:00';
      }

      if(this.pickupTimeFrom == '' && this.pickupTimeUntil == ''){
        // Ako nema odabranih vremena
        startFromHour = this.findRoundHour(dayStartingTime);
        endFromHour = '18:00'
        startUntilHour = this.findRoundHour(startFromHour);
        endUntilHour = '20:00';
      } else if(this.pickupTimeFrom == '' && this.pickupTimeUntil != ''){
        // Ako je until vec odabran
        startFromHour = this.findRoundHour(dayStartingTime);
        endFromHour = this.findEndHour(this.pickupTimeUntil);
        startUntilHour = this.pickupTimeUntil;
        endUntilHour = '20:00';
      } else if (this.pickupTimeFrom != '' && this.pickupTimeUntil == ''){
        // Ako je from vec odabran, a nema until
        startFromHour = this.pickupTimeFrom;
        endFromHour = '18:00';
        startUntilHour = this.addHour(this.pickupTimeFrom);
        endUntilHour = '20:00';
      } else if (this.pickupTimeFrom  != '' && this.pickupTimeUntil != ''){
        // Ako ima obe vrednosti
        startFromHour = this.findRoundHour(dayStartingTime);
        endFromHour = this.findEndHour(this.pickupTimeUntil );
        startUntilHour = this.addHour(this.pickupTimeFrom);
        endUntilHour = '20:00';
      }
      return{
        from: this.findArrayRangeHours(startFromHour, endFromHour),
        until: this.findArrayRangeHours(startUntilHour, endUntilHour),
      }
    },
  },
  created() {
    if (this.get_booking_systems){
      const systemSettings = this.get_booking_systems.items[0];
      const otherNotificationEvents = systemSettings.other_shipment_notification_events_array;
      this.shipmentNotification = systemSettings.shipment_notification.toString();

      if (otherNotificationEvents && otherNotificationEvents.includes('deviations')) {
        this.selectedDeviations = true;
      }
      if (otherNotificationEvents && otherNotificationEvents.includes('change')) {
        this.selectedStatusChange = true;
      }
      if (otherNotificationEvents && otherNotificationEvents.includes('delivered')) {
        this.selectedDeliver = true;
      }
    }
    if(this.product.insurance_categories != null){
      for (const key in this.product.insurance_categories) {
        this.insuranceCategoriesOptions.push({
          text: `${this.$t(key)}`,
          value: key,
        })
      }

      if (this.product.insurance_category) {
        this.insuranceCategory = this.product.insurance_category;
      } else {
        this.insuranceCategory = this.insuranceCategoriesOptions[0].value;
      }
    }

    if (this.product.droppoints != null) {
      this.product.droppoints.forEach((dp) => {
        if (dp.number) {
          const text = `(${dp.driving_distance} km) ${dp.company_name}, ${dp.address}, ${dp.zip_code} ${dp.city}`;
          this.droppointAddressOptions.push({
            value: dp.number,
            text: text
          })
        }

        if (this.editShipmentDroppointNo) {
          this.droppointNo = this.editShipmentDroppointNo;
        }

        //First droppoint is the closest one, so preselect him
        if (dp.number && !this.droppointNo) {
          this.droppointNo = dp.number
        }
      })
    }

    //If product is dropp off only then do not set pickup times
    if (this.product.product_handling_type !== '1' ) {
      this.pickupDriverNote = this.editPickupDriverNote;
      this.pickupTimeUntil = this.editPickupTimeUntil;
      this.pickupTimeFrom = this.editPickupTimeFrom;
    }

    this.pickupToggle = !!(this.pickupTimeUntil && this.pickupTimeFrom);

    if (this.customsData?.freight_payer_id && this.customsData?.freight_paid_by == 4) {
      console.log(this.customsData.freight_payer_id)
      this.$store.dispatch('GET_PAYER_CARRIERS', {id: this.customsData.freight_payer_id});
    }
  },
  methods: {
    getTotalPriceText(product) {
      this.user_vat_percent = this.get_user.vat_user_percent;
      return Number(product.prices_data.vat_percent) ?  this.$t('total_incl_vat') : this.$t('total');
    },
    addHour(hour){
      let hours = Number(hour.slice(0, 2)) + 1;
      if(hours.toString().length == 1) hours = '0' + hours;
      let minutes = hour.slice(3);
      return hours + ':' + minutes;
    },
    findRoundHour(hour){
      let hours = Number(hour.slice(0, 2)) + 1;
      if(hours.toString().length == 1) hours = '0' + hours;
      return hours + ':' + '00';
    },
    findEndHour(hour) {
      let hours = Number(hour.slice(0, 2)) - 1;
      if(hours.toString().length == 1) hours = '0' + hours;
      let minutes = hour.slice(3);
      return hours + ':' + minutes;
    },
    findArrayRangeHours(from, to) {
      let arr = [...this.scheduleHours];
      return arr.slice(arr.indexOf(from), arr.indexOf(to) + 1).map((time) => {
        return {text: time, value: time};
      });
    },
    getFormatedDate(dateTime) {
      let d = new Date(dateTime);
      let day = d.getDate();
      let month = d.getMonth() + 1;
      let hours = String(d.getHours());
      let minutes = String(d.getMinutes());

      if (day < 10) day = `0${day}`
      if (month < 10) month = `0${month}`
      if (hours.length == 1) hours = `0${hours}`
      if (minutes.length == 1) minutes = `0${minutes}`

      return {
        date: `${d.getFullYear()}-${month}-${day}`,
        time: `${hours}:${minutes}`,
      };
    },
    changeInsuranceCategory(val) {
      this.$emit('updateInsuranceCategory', val);
    },
    otherNotification() {
      this.selectedOther = !this.selectedOther;
      if(!this.selectedOther) {
        this.otherMail = '';
      }
    },
    selectOptions(obj) {
      const options = [];
      for (const property in obj) {
        options.push({ text: obj[property], value: parseInt(property) });
      }
      return options;
    },
    selected() {
      if(this.isDisabled || this.isDisabledByService || this.isDisabledByAPI) return;
      this.$emit('selected', {
        allowedServices: this.product.allowed_services,
        product: this.product,
      });
    },
    dispatchShipment() {
      let notificationReciever = [];
      if(this.selectedReciever) notificationReciever.push({name: 'receiver', email: ''});
      if(this.selectedShipper) notificationReciever.push({name: 'shipper', email: ''})
      if(this.selectedMe) notificationReciever.push({name: 'me', email: ''})
      if(this.selectedOther) notificationReciever.push({name: 'other', email: this.otherMail})

      let otherNotifications = [];
      if(this.selectedStatusChange) otherNotifications.push('change');
      if(this.selectedDeviations) otherNotifications.push('deviations')
      if(this.selectedDeliver) otherNotifications.push('delivered')

      if(this.pickupToggle || parseInt(this.product.product_handling_type) === 2){
        if(this.pickupTimeFrom == '' || this.pickupTimeUntil == '') {
          EventBus.$emit('checkSubmitErrors');
          return;
        };
      }

      this.$emit('triggerShipment', {
        shipmentNotificationType: this.shipmentNotification,
        notification_receiver: notificationReciever,
        other_notification_event: otherNotifications,
        pickup_time_from: this.pickupTimeFrom,
        pickup_time_until: this.pickupTimeUntil,
        pickup_driver_note: this.pickupDriverNote,
        pickup_ship_date: this.newPickupDate ? this.newPickupDate : this.pickupDate,
        pickup_action: this.pickupAction,
        droppoint_no: this.droppointNo,
        product: this.product,
        freight_booking_confirmation_no: this.freight_booking_confirmation_no
      });
    },
    openPopup() {
      this.isOpenedPopup = true;
    },
    closePopup() {
      this.isOpenedPopup = false;
    },
    changeNotification() {
      this.isOpenedPopup = false;
    },
  },
  watch: {
    pickupToggle(val) {
      if(!val){
        this.pickupTimeFrom = '';
        this.pickupTimeUntil = '';
        this.pickupDriverNote = '';
        this.pickupAction = '';
      }
    },
  },
}
</script>
